<template>
  <div class="page-sidebar">
    <!-- mobile view -->
    <div
        v-if="isMobile()"
        ref="ref-mobile-search"
        class="mobile-search fixed"
        data-click-flash-tab
    >
      <div
          id="options-collapse"
          class="options"
      >
        <div class="options__buttons">

          <!-- banner button-->
          <button
              ref="ref-options-banner-button"
              class="d-none"
              type="button"
              data-toggle="collapse"
              data-target="#options-banner"
              aria-expanded="true"
              aria-controls="banner-filter"
          />

          <!-- search button-->
          <button
              ref="ref-options-search-button"
              class="clean tab"
              type="button"
              data-toggle="collapse"
              data-target="#options-search"
              aria-expanded="false"
              aria-controls="search-filter"
              @click="onClickSearchButtonMobile"
          >
            <i class="fas fa-search"></i>
          </button>

          <!-- filter button-->
          <button
              ref="ref-options-filter-button"
              class="clean tab"
              type="button"
              data-toggle="collapse"
              data-target="#options-filter"
              aria-expanded="false"
              aria-controls="add-filter"
              @click="onClickFilterButtonMobile"
          >
            <i class="fas fa-sliders-h"></i>
            <p
                v-if="0 !== totalFilters"
                class="total-active-filters"
            >
              {{ totalFilters }}
            </p>
          </button>

          <!-- newsletter button -->
          <button
              v-if="newsletterShow"
              ref="ref-options-mail-button"
              :class="[alertNewsletterSubscription ? 'show-notification-dot' : '', 'clean', 'tab', 'newsletter-subscribe-button']"
              type="button"
              data-toggle="collapse"
              data-target="#options-mail"
              aria-expanded="false"
              aria-controls="delete-filter"
              @click="onClickMailButtonMobile"
          >
            <i class="fas fa-bell"></i>
          </button>
        </div>
        <div class="options__content">

          <form
              id="find-house-form-filter"
              method="post"
              data-select-advanced-form=""
              :action="searchRedirect"
          >

            <!-- rental banner -->
            <div
                id="options-banner"
                class="collapse show"
                data-parent="#options-collapse"
            >
              <adivare-results-loading :show-spinner="false" v-on:loadingIsReady="loadingIsReady">
                <adivare-text-banner
                    show-rental-type
                    show-city-name
                    class="rental-list-banner"
                />
              </adivare-results-loading>
            </div>

            <!-- search form -->
            <div
                id="options-search"
                class="collapse"
                data-parent="#options-collapse"
            >
              <adivare-results-loading :show-spinner="false">
                <!-- total results banner -->
                <adivare-text-banner show-rental-type></adivare-text-banner>

                <!-- search filter -->
                <adivare-filter-search></adivare-filter-search>
              </adivare-results-loading>
            </div>

            <!-- filter content -->
            <div
                id="options-filter"
                ref="ref-options-filter-content"
                class="collapse"
                data-parent="#options-collapse"
            >
              <adivare-results-loading>
                <div class="filter-container">

                  <!-- order filter -->
                  <adivare-results-order
                      @updateCounts="updateCounts"
                  ></adivare-results-order>

                  <!-- delete filter -->
                  <adivare-filter-delete
                      @updateCounts="updateCounts"
                  ></adivare-filter-delete>

                  <!-- add filter -->
                  <adivare-filter-add
                      @updateCounts="updateCounts"
                  ></adivare-filter-add>

                  <!-- submit button -->
                  <div class="submit-button">
                    <button
                        class="btn btn-theme fixed-bottom clean show-results"
                        @click="onClickSubmitButton"
                        :disabled="!this.$store.state.allowUpdates"
                    >
                      <adivare-text-submit-button v-if="this.$store.state.allowUpdates" count-expected></adivare-text-submit-button>
                      <p v-else>{{ $t('messages_nl.search.loading') }}...</p>
                    </button>
                  </div>
                </div>
              </adivare-results-loading>
            </div>
          </form>

          <!-- newsletter content -->
          <div
              id="options-mail"
              class="collapse"
              data-parent="#options-collapse"
          >

            <!-- newsletter subscription form -->
            <adivare-newsletter-subscribe
                v-if="newsletterShow"
                :newsletter-html="newsletterHtml"
            ></adivare-newsletter-subscribe>
          </div>
        </div>
      </div>
    </div>

    <!-- desktop view -->
    <adivare-results-loading v-else :show-spinner="false">
      <form
          id="find-house-form-filter"
          method="post"
          data-select-advanced-form=""
          :action="searchRedirect"
      >

        <!-- filter content -->
        <div class="filter-container">
          <h3
              class="form-title"
              v-html="$t('messages_nl.catalog.search')"
          ></h3>

          <!-- search filter -->
          <adivare-filter-search></adivare-filter-search>

          <!-- add filter -->
          <adivare-filter-add
              ref="collapse"
              @updateFilters="updateFilters"
              @clicked="scrollToTop"
          >

            <!-- delete filter -->
            <adivare-filter-delete
                @updateFilters="updateFilters"
                @clicked="scrollToTop"
            />
          </adivare-filter-add>
        </div>

        <!-- Form won't submit on enter if there's multiple form fields present and there is no submit element. -->
        <input
            type="submit"
            class="d-none"
        />
      </form>
    </adivare-results-loading>
  </div>
</template>

<script>

import scroll from "../../../../common/js/util/scroll";
import FlashTab from "../../../../common/js/components/flashTab";

export default {
  name: 'adivare-search-form',
  props: {
    // legacy filters from php search controller
    legacyFilters: {
      type: Object,
    },
    // form redirect url
    searchRedirect: {
      type: RegExp,
    },
    // form title
    title: {
      type: String,
      default: '',
      required: false,
    },
    // alert user to subscribe to newsletter with red dot
    alertNewsletterSubscription: {
      type: Boolean,
      default: false,
      required: false,
    },
    // html for newsletter subscribe form
    newsletterHtml: {
      type: String,
      default: '',
      required: false,
    },
    // show newsletter subscribe form
    newsletterShow: {
      type: Boolean,
      default: false,
      required: false,
    },
    // breakpoint. The viewport width. Decides if view is mobile or desktop
    mobileBreakpoint: {
      type: Number,
      default: 576, // bootstrap grid xs is 576px wide
      required: false,
    },
  },
  data() {
    return {
      configuration: {
        bootstrapCollapseTime: 400,             // time in milliseconds when bootstrap content is collapsed.
        searchMenuOffset: {
          init: 'collapsed',                    // initial setup: collapsed or expanded
          fromElement: '[data-search-results]', // offset from html element
        }
      },
      filters: {
        ...this.$store.state.defaultFilters,
        location: undefined,
        suggestId: undefined,
        suggestType: undefined,
        page: 1,
      },
      totalFilters: 0,
    }
  },
  computed: {
    defaultFilters() {
      return this.$store.state.defaultFilters;
    },
    searchMenuOffsetCollapsed() {
      return (this.$store.state.loginHouseCount > this.$store.state.houseCount) ? 148.94 : 123.28;
    },
    searchMenuOffsetExpanded() {
      return (this.$store.state.loginHouseCount > this.$store.state.houseCount) ? 218.84 : 193.19;
    },
  },
  created() {
    this.mapFiltersReverse(this.legacyFilters);
    this.dispatchUpdateFilters();
    this.$store.commit('updateDefaultFiltersLocation', this.legacyFilters.location.location);
  },
  methods: {
    // check if viewport is in mobile view
    isMobile() {
      return window.innerWidth <= this.mobileBreakpoint
    },
    loadingIsReady() {
      if (true === this.isMobile()) new FlashTab();
      this.toggleHeightSearchContainer();
    },
    getTotalFilters(total) {
      this.totalFilters = total;
    },
    // Click event on submit button of filter form
    onClickSubmitButton() {
      this.updateFilters({page: 1});
      this.scrollToTop();
      this.$refs['ref-options-filter-button'].click();
    },
    // Click event on filter button
    onClickFilterButtonMobile(event) {
      this.setCollapsedOrExpandedMenu(event, true);
      // always start at top of scroll position when filter form is opened
      this.$refs['ref-options-filter-content'].scrollTop = 0;
    },
    // Click event on search button
    onClickSearchButtonMobile(event) {
      this.setCollapsedOrExpandedMenu(event);
    },
    // Click event on newsletter button
    onClickMailButtonMobile(event) {
      this.setCollapsedOrExpandedMenu(event, true);
    },
    setCollapsedOrExpandedMenu(event, forceCollapse = false) {
      if ('true' === event.currentTarget.getAttribute('aria-expanded')) {
        this.$refs['ref-options-banner-button'].click();
        this.toggleHeightSearchContainer(true);
      } else {
        this.toggleHeightSearchContainer(forceCollapse);
      }
    },
    // Toggle height of search list
    toggleHeightSearchContainer(collapse = true) {
      if (true === this.isMobile()) {
        let conf = this.configuration.searchMenuOffset;
        document.querySelectorAll(conf.fromElement)[0].style.marginTop = (true === collapse ? this.searchMenuOffsetCollapsed : this.searchMenuOffsetExpanded) + 'px';
      }
    },
    // Get readable text from english to dutch from options
    getTranslatedNameFromOptions(options, value) {
      for (const option of options) {
        if (
            'undefined' !== typeof option.value &&
            'undefined' !== typeof option.name &&
            option.value === value
        ) {
          return option.name;
        }
      }

      return '';
    },
    // update filters
    updateFilters(filters = null) {
      if (null !== filters) {
        Object.assign(this.filters, filters);
      }
      this.dispatchUpdateFilters();
    },
    // Scroll to body top
    scrollToTop() {
        scroll.toTop();
    },
    // update counts
    updateCounts(filters = null) {
      if (null !== filters) {
        Object.assign(this.filters, filters);
      }
      this.dispatchUpdateCounts();
    },
    // dispatch updated filters to vue-search-base
    dispatchUpdateFilters() {
      this.$store.dispatch('updateFilters', this.mapFilters());
      this.mapFiltersReverse(this.$store.state.filters);
    },
    // dispatch updated counts to vue-search-base
    dispatchUpdateCounts() {
      this.$store.dispatch('updateCounts', this.mapFilters());
      this.mapFiltersReverse(this.$store.state.filters);
    },
    // official filters template used in vue-search-base
    mapFilters() {
      return {
        location: {
          location: this.filters.location,
          distance: this.filters.distance,
          suggestType: this.filters.suggestType,
          suggestId: this.filters.suggestId,
          neighborhoodSlug: this.filters.neighborhoodSlug,
          streetSlug: this.filters.streetSlug,
          districtSlug: this.filters.districtSlug,
        },
        price: {
          from: this.filters.from,
          till: this.filters.till,
        },
        properties: {
          rooms: this.filters.rooms,
          livingArea: this.filters.livingArea,
          deliveryLevel: this.filters.deliveryLevel,
          rentalType: this.filters.rentalType,
          outside: this.filters.outside,
        },
        radiusHasChanged: this.radiusHasChanged,
        page: this.filters.page,
        sorting: this.filters.sorting,
      };
    },
    // practical and non-nested filters template used in most vue templates, except vue-search-base
    mapFiltersReverse(values) {
      this.filters.location = values.location.location;
      this.filters.suggestType = values.location.suggestType;
      this.filters.suggestId = values.location.suggestId;
      this.filters.distance = values.location.distance;
      this.filters.neighborhoodSlug = values.location.neighborhoodSlug;
      this.filters.streetSlug = values.location.streetSlug;
      this.filters.districtSlug = values.location.districtSlug;
      this.filters.from = values.price.from;
      this.filters.till = values.price.till;
      this.filters.rooms = values.properties.rooms;
      this.filters.livingArea = values.properties.livingArea;
      this.filters.deliveryLevel = values.properties.deliveryLevel;
      this.filters.rentalType = values.properties.rentalType;
      this.filters.outside = values.properties.outside;
      this.filters.page = values.page;
      this.filters.sorting = values.sorting;
      this.radiusHasChanged = values.radiusHasChanged;
    }
  }
}
</script>
